module.exports = __webpack_public_path__ + "static/flags/RW-39f1d10d50f6d7abc4fb57b858ab6413.gif";